var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "telegram_svg__a",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6567_36493"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0287811 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_6567_36493",
    result: "effect2_dropShadow_6567_36493"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_6567_36493",
    result: "effect3_dropShadow_6567_36493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_6567_36493",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "telegram_svg__currentLayer"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.329 45.162a8.645 8.645 0 01-2.445-2.43 9.016 9.016 0 01-1.34-3.228 79.167 79.167 0 01-.03-30.967A8.941 8.941 0 012.84 5.33c1.333-1.985 3.365-3.344 5.654-3.782a79.218 79.218 0 0130.972-.037l-.004.008a8.858 8.858 0 013.214 1.322 8.675 8.675 0 012.441 2.433 9.046 9.046 0 011.34 3.229 79.225 79.225 0 01.03 30.964 8.895 8.895 0 01-1.327 3.208c-1.335 1.985-3.368 3.344-5.66 3.781a79.236 79.236 0 01-30.966.035 8.85 8.85 0 01-3.206-1.328z",
    fill: "#00A1DC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.604 14.926c-.278-.339-.694-.526-1.172-.526-.26 0-.535.055-.818.163l-19.262 7.333c-1.023.389-1.16.973-1.151 1.286.008.313.18.889 1.222 1.22a.66.66 0 00.018.005l3.996 1.14 2.16 6.162c.295.84.957 1.362 1.727 1.362.485 0 .963-.203 1.381-.586l2.471-2.27 3.585 2.879h.001l.034.028a.622.622 0 00.01.007c.398.309.833.471 1.258.471.83 0 1.491-.612 1.684-1.56l3.156-15.542c.126-.624.02-1.182-.3-1.572zm-15.83 10.405l7.708-3.928-4.8 5.087a.665.665 0 00-.162.296l-.925 3.739-1.821-5.194zm3.028 6.175a1.3 1.3 0 01-.096.08l.858-3.469 1.562 1.255-2.324 2.134zm11.795-15.272L29.44 31.776c-.03.148-.128.495-.377.495-.123 0-.278-.067-.437-.19l-4.062-3.26a.01.01 0 00-.001-.002l-2.417-1.941 6.94-7.355a.664.664 0 00.049-.855.668.668 0 00-.837-.193L16.883 24.29l-4.05-1.155 19.256-7.33a.98.98 0 01.343-.076c.04 0 .113.005.14.038.036.043.08.19.025.466z",
    fill: "#FFF5F5"
  }))));
}
export default SvgTelegram;